import { useGetComponentsQuery, ComponentInfoFragment } from 'gqlTypes'

// This is a valid use case to narrow down Component type
// eslint-disable-next-line no-restricted-imports
import { TextStyle } from 'gqlTypes/expansiveTypes'

import { useGetIdentifiers } from './useGetIdentifiers'

const isTextStyleComponent = (
  component?: ComponentInfoFragment
): component is TextStyle => component?.__typename === 'TextStyle'

export const useGetTextStyles = (search?: string) => {
  const { shareIdentifier, versionShortId } = useGetIdentifiers()
  const { loading, data, refetch, fetchMore } = useGetComponentsQuery({
    variables: {
      shareIdentifier,
      versionShortId,
      type: 'TEXT_STYLE',
      search,
    },
  })

  return {
    loading,
    filter: (path: string | null) => refetch({ path }),
    fetchMore,
    entries:
      data?.share?.version?.document?.components.entries.filter(
        isTextStyleComponent
      ) || [],
    meta: data?.share?.version?.document?.components.meta,
  }
}
